import { getTrackingCollectionAttributes } from 'homepage/utils/getTrackingCollectionAttributes';

/**
 * [getSearchLandingFeedSectionTrackingInfo]
 * All of the tracking events for homepage content require these 5 attributes.
 * They're passed down into each section, so we can fire events from deeper down in the tree. (ported from old goat.com)
 *
 * @param   {Object} section      The section itself.
 * @param   {Number} sectionIndex Position of section in list, starting at 0
 * @param   {Number} draftId      Draft ID for current feed
 * @param   {Number} sectionSubsectionPosition Position of section in list, starting at 0
 * @param   {Number} section    the current section
 * @returns {Object}
 */
export const getSearchLandingFeedSectionTrackingInfo = (
  section,
  sectionIndex,
  draftId,
  context = 'search_landing',
) => {
  const collectionAttr = getTrackingCollectionAttributes(section);

  return {
    event_context: context,
    draft_id: draftId,
    section_id: section?.id,
    section_position: sectionIndex,
    section_type: section?.type,
    section_name: section?.title || section?.subject,
    ...collectionAttr,
  };
};
